'use client';
import { TransitionStartFunction } from 'react';
import { useTranslations } from 'next-intl';
import { Equipment, ServiceInsightDetailProps } from 'services/equipment/types';
import { CatCard } from 'components/blocks-components';
import AddEquipmentWidget from 'components/my-equipment/add-equipment-widget/add-equipment-widget';
import SingleEquipmentCard from '../single-equipment-card';

type SingleEquipmentWidgetProps = {
  equipment: Equipment;
  isDetailsCard?: boolean;
  userDetail: {
    isLoggedIn?: boolean;
    registerUrl?: string;
    isCspUser?: boolean;
    isDealerUser?: boolean;
  };
  serviceInsightsDetails: ServiceInsightDetailProps;
  isRequestServiceFlag: boolean;
  startTransition: TransitionStartFunction;
};

const SingleEquipmentWidget = ({
  equipment,
  isDetailsCard,
  userDetail,
  serviceInsightsDetails,
  isRequestServiceFlag,
  startTransition
}: Readonly<SingleEquipmentWidgetProps>) => {
  const t = useTranslations();
  return (
    <div className="row justify-content-between gap-4 gap-lg-0">
      <SingleEquipmentCard
        equipment={equipment}
        isDetailsCard={isDetailsCard}
        userDetail={userDetail}
        isRequestServiceFlag={isRequestServiceFlag}
        serviceInsightsDetails={serviceInsightsDetails}
        startTransition={startTransition}
      />

      <div className="col-lg-6 col-12 p-0 ps-3 pe-3">
        <CatCard removePadding>
          <AddEquipmentWidget
            title={t('ADD_MORE_EQUIPMENT_TITLE')}
            isLoggedIn={userDetail?.isLoggedIn}
            showNotifyDealer={userDetail?.isCspUser}
          />
        </CatCard>
      </div>
    </div>
  );
};

export default SingleEquipmentWidget;
